// The history entry the viewer writes for each node it shows. Entries are read back on `popstate`
// to step the tree. Only entries this document wrote are followed: a reload keeps the previous
// document's entries, and the nodes they name are not part of this document's walk, so such an
// entry is rewritten for the node on screen when the browser lands on it.
const HISTORY_NAMESPACE = "decision-tree-nav";

const DOCUMENT_ID = Math.random().toString(36).slice(2);

export function historyEntry(currentNodeId) {
  return { namespace: HISTORY_NAMESPACE, document: DOCUMENT_ID, currentNodeId };
}

export function isOwnEntry(state) {
  return state?.namespace === HISTORY_NAMESPACE && state.document === DOCUMENT_ID;
}

export function isForeignEntry(state) {
  return state?.namespace === HISTORY_NAMESPACE && state.document !== DOCUMENT_ID;
}
